import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import md5 from "md5"

// Login Redux States
import {
  AUTH_LOGIN,
  AUTH_LOGIN_ERROR,
  AUTH_SOCIAL_LOGIN,
  AUTH_LOGOUT,
} from "./actionTypes"

import {
  authLoginSuccess,
  authLoginFail,
  authLogoutUserSuccess,
} from "./actions"

import {
  SetCampusVirtualIdCampus,
  SetCampusVirtualListaCampi,
  SetCampusVirtualAuthenticatedUser,
  SetCampusVirtualLogout,
  SetCampusVirtualListaConfiguraciones,
} from "../../campusvirtual/actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeLogin,
  postJwtLogin,
  postJwtLogin2,
  postSocialLogin,
  getListaCampus,
} from "../../../helpers/campusvirtualbackend_helper"

const fireBaseBackend = getFirebaseBackend()

function* authLoginUser2({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      )
      yield put(authLoginSuccess(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      try {
        const response = yield call(postJwtLogin2, user)
        if (response.Status === "success") {
          console.log("response: ", response)
          //
          //-----------------------------------------------------------
          // Código duplicado
          const oAuthUser = response.Datos.oPersona
          //-----------------------------------------------------------
          // Saco en un arreglo los ids de los campus con permiso
          const arregloUsuarioCampi = obtenerNumerosRoles(oAuthUser.Lista_Roles)
          if (arregloUsuarioCampi.length === 0) {
            yield put(
              authLoginFail("No tienes permiso para entrar a esta app.")
            )
            return
          } else {
            // ¿Tiene permitido cualquier campus?
            if (arregloUsuarioCampi.includes(0)) {
              // Siempre lo meteremos al primer campus
              localStorage.setItem("idCampusSelected", 1)
              yield put(SetCampusVirtualIdCampus(1))
            } else {
              // No tiene permitido cualquier campus
              const idCampusLocalStorage =
                localStorage.getItem("idCampusSelected")
              // Dentro de los permisos ¿está el LocalStorage_id_Campus?
              if (arregloUsuarioCampi.includes(idCampusLocalStorage)) {
                yield put(SetCampusVirtualIdCampus(idCampusLocalStorage))
              } else {
                // Si no está localStorage_id_Campus dentro de los permisos
                localStorage.setItem("idCampusSelected", arregloUsuarioCampi[0])
                yield put(SetCampusVirtualIdCampus(arregloUsuarioCampi[0]))
              }
            }
          }
          yield put(authLoginSuccess(oAuthUser))
          localStorage.setItem("authUser", JSON.stringify(oAuthUser))
          //
          const dataCampi = response.Datos.dataCampi
          yield put(SetCampusVirtualListaCampi(dataCampi))
          //
          const configuracion = response.Datos.configuracion
          //console.log("configuracion: ", configuracion)
          yield put(SetCampusVirtualListaConfiguraciones(configuracion))
          //-----------------------------------------------------------
          const obj = JSON.parse(JSON.stringify(oAuthUser))
          obj.avatarUrl = getGravatarUrl(obj.Email_Personal)
          yield put(SetCampusVirtualAuthenticatedUser(obj))
          //-----------------------------------------------------------
          history("/dashboard")
        } else {
          console.log("response: ", response)
          yield put(authLoginFail(response.Mensaje_Detalle))
          return
        }
      } catch (error) {
        console.log(error)
        const mensaje = error.response
          ? error.response.data
            ? error.response.data.Mensaje_Detalle
              ? error.response.data.Mensaje_Detalle
              : error.message
            : error.message
          : error.message
        yield put(authLoginFail(mensaje))
      }
    }
  } catch (error) {
    console.log("loginUser::catch::general::error: " + error)
    yield put(
      authLoginFail(error.mensaje_Detalle ? error.mensaje_Detalle : error)
    )
  }
}

function* authLogoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    setTimeout(() => {
      history("/login")
    }, 500)
  } catch (error) {
    yield put(authLoginFail(error))
  }
}

function* authSocialLogin2({
  payload: { type, history, idColegio, GMT_Offset },
}) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const fireBaseBackend = getFirebaseBackend()
      let response = yield call(fireBaseBackend.socialLoginUser, type)
      if (!response) {
        yield put(authLoginFail("No hubo respuesta del proveedor Google"))
      } else {
        const data = {
          id_colegio: idColegio,
          provider: "google",
          access_token: response.firebaseToken,
          GMT_Offset: GMT_Offset,
        }
        response = yield call(postJwtLogin2, data)
        if (response.Status === "success") {
          //
          //-----------------------------------------------------------
          // Código duplicado
          const oAuthUser = response.Datos.oPersona
          //-----------------------------------------------------------
          // Saco en un arreglo los ids de los campus con permiso
          const arregloUsuarioCampi = obtenerNumerosRoles(oAuthUser.Lista_Roles)
          if (arregloUsuarioCampi.length === 0) {
            yield put(
              authLoginFail("No tienes permiso para entrar a esta app.")
            )
            return
          } else {
            // ¿Tiene permitido cualquier campus?
            if (arregloUsuarioCampi.includes(0)) {
              // Siempre lo meteremos al primer campus
              localStorage.setItem("idCampusSelected", 1)
              yield put(SetCampusVirtualIdCampus(1))
            } else {
              // No tiene permitido cualquier campus
              const idCampusLocalStorage =
                localStorage.getItem("idCampusSelected")
              // Dentro de los permisos ¿está el LocalStorage_id_Campus?
              if (arregloUsuarioCampi.includes(idCampusLocalStorage)) {
                yield put(SetCampusVirtualIdCampus(idCampusLocalStorage))
              } else {
                // Si no está localStorage_id_Campus dentro de los permisos
                localStorage.setItem("idCampusSelected", arregloUsuarioCampi[0])
                yield put(SetCampusVirtualIdCampus(arregloUsuarioCampi[0]))
              }
            }
          }
          yield put(authLoginSuccess(oAuthUser))
          localStorage.setItem("authUser", JSON.stringify(oAuthUser))
          //
          const dataCampi = response.Datos.dataCampi
          yield put(SetCampusVirtualListaCampi(dataCampi))
          //
          const configuracion = response.Datos.configuracion
          //console.log("configuracion: ", configuracion)
          yield put(SetCampusVirtualListaConfiguraciones(configuracion))
          //-----------------------------------------------------------
          const obj = JSON.parse(JSON.stringify(oAuthUser))
          obj.avatarUrl = getGravatarUrl(obj.Email_Personal)
          yield put(SetCampusVirtualAuthenticatedUser(obj))
          //-----------------------------------------------------------
          history("/dashboard")
        } else {
          yield put(authLoginFail(response.Mensaje_Detalle))
          history("/login")
        }
      }
    }
  } catch (error) {
    //console.log("loginState::saga::function* authSocialLogin::", error)
    const mensaje = error.response
      ? error.response.data
        ? error.response.data.Mensaje_Detalle
          ? error.response.data.Mensaje_Detalle
          : error.message
        : error.message
      : error.message
    yield put(authLoginFail(mensaje))
  }
}

function obtenerNumerosRoles(Lista_Roles) {
  const prefijo = "sis_usuarios_campus_"
  const numeros = []

  for (let key in Lista_Roles) {
    const value = Lista_Roles[key]
    if (typeof value === "string" && value.startsWith(prefijo)) {
      const numero = value.slice(prefijo.length)
      if (!isNaN(numero)) {
        // Verifica que sea un número
        numeros.push(parseInt(numero, 10))
      }
    }
  }

  return numeros
}

const getGravatarUrl = email => {
  if (email) {
    const hash = md5(email.trim().toLowerCase()) // Hash en minúsculas
    return `https://www.gravatar.com/avatar/${hash}`
  } else {
    return user1
  }
}

function* authSaga() {
  yield takeEvery(AUTH_LOGIN, authLoginUser2)
  yield takeEvery(AUTH_LOGIN_ERROR, authLoginFail)
  yield takeLatest(AUTH_SOCIAL_LOGIN, authSocialLogin2)
  yield takeEvery(AUTH_LOGOUT, authLogoutUser)
}

export default authSaga
